var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"progress"}},[_c('div',{staticClass:"progress-bar"},_vm._l((_vm.max),function(n){return _c('div',{key:n,staticClass:"meter",class:{ active: n <= _vm.value }},[_vm._v("   ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }